<template>
    <div class="row mx-0">
        <div class="col-md-7 ml-sm-0 col-lg-7 pt-1 px-1">
            <div id="map" class="min-h-50"></div>
            <div v-if="isNew" class="consigne">
                <h5>{{ trans.get('common.move_marker_to_building') }}</h5>
            </div>
        </div>
        <div class="col-md-5 ml-sm-0 col-lg-5 pt-1 px-1 pl-5">
            <h5>{{ trans.get('common.zone_type') }} :</h5>
            <div v-if="modifier">
                <div class="form-group">
                    <select id="SelectTypeField" class="form-control" v-model="type" v-on:change="changedTypeZone()" required>
                        <option disabled value="">{{ trans.get('common.choose') }}</option>
                        <option value="Roof">Roof</option>
                        <option value="Ground">Ground</option>
                        <option value="Parking">Parking</option>
                    </select>
                </div>
            </div>
            
            <div v-if="!modifier">
                <div class="row mx-0">
                    <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1">
                        <h6  class="pl-5 my-0" >{{type}}</h6>
                    </div>
                    <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1">
                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="modifier=true" :title="trans.get('common.edit')">
                            <span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- RECAP ZONE -->

            <p>
                <div class = "row mx-0">
                    <h5> {{ trans.get('common.latitude') }} :</h5>
                    <h6 id ="latitudeLabel" class="pl-5" >{{latitude}}</h6>
                </div>
            </p>
            <p>
                <div class = "row mx-0">
                    <h5> {{ trans.get('common.longitude') }} :</h5>
                    <h6 id ="longitudeLabel" class="pl-5">{{longitude}}</h6> 
                </div>
            </p>
            <p>
                <div class = "row mx-0">
                    <h5> {{ trans.get('common.nomZone')}} :</h5>
                    <input name="nomZone" id="nomZone" class="form-control " type="text" v-model="nomZone"  />
                </div>
            </p>
            <p>
                <div class ="row mx-0">
                    <h5> {{ trans.get('common.pv_ready_coef')}} :</h5>
                    <h6 v-if="!modifier" class="pl-5">{{CoeffPvReady}} </h6>
                    <input required id="CoeffPvReady" name="CoeffPV-Ready"  type="text" class="form-control"  v-if="modifier"  v-model="CoeffPvReady" :readonly="isRoof"/>
                </div>
            </p>    
            <p>
                <div class = "row mx-0">
                    <h5> {{ trans.get('common.zonetotalesurface')}} :</h5>
                    <h6 v-if="!modifier" class="pl-5">{{this.zone.surfaceTotale}}&nbsp;m²</h6>
                    <input v-if="modifier" required id="surfaceTotale" name="surfaceTotale" class="form-control" type="number" v-model="surfaceTotale">
                </div>
            </p>         
            <p>
                <div class = "row mx-0" v-if="!isNew">
                    <h5>{{ trans.get('common.zonecoveredsurface')}} :</h5> 
                    <h6 class="pl-5">{{this.zone.surfacePV}}&nbsp;m²</h6>
                </div>
            </p>
            <p>
                <div class = "row mx-0">
                    <h5>{{ trans.get('common.a_prendre')}} :</h5> 
                    <input id="a_prendre" type="checkbox" class="buttonOriginal3 mx-3 my-3" style="margin-top: 0px!important;" name="a_prendre" v-model="aprendre">
                </div>
            </p>
            <!-- FIN RECAP ZONE -->

            <div class="row">
                <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1">
                    <input name="name" type="hidden" id="name" style="visibility:hidden" >
                    <input name="latitude" type="hidden" id="latitude" style="visibility:hidden" >
                    <input name="longitude" type="hidden" id="longitude" style="visibility:hidden" >
                    <input v-if="isNew" name="zone_ID" type="hidden" id="zone_ID" style="visibility:hidden" >               
                    <button type="submit" class="buttonOriginal" aria-label="Left Align" v-on:click="save()" :title="trans.get('common.save')">
                        <span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span>
                    </button>
                </div>
                <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1">
                    <button type="button" class="buttonOriginal" aria-label="Left Align"  v-on:click="back()" :title="trans.get('common.backtosite')">
                        <span class="glyphicon glyphicon-step-backward" aria-hidden="true"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script >
    export default {
        props : ['site', 'zone', 'pvfieldsdraw', 'is_new', 'formid', 'deja_modifier','pvready'],     
        data : function(){
            return {
                longitude: 0,
                latitude: 0,
                surfaceTotale:1,
                nomZone: "",
                comments:"",
                type: "",
                isNew: !!this.is_new,
                idZone:"",
                modifier:false,
                clickLong:0,
                clickArea:0,
                clickMesure:0,
                pointMesure:[],
                fixePoint:[],
                flightPath:{},
                mouvePoint:{},
                firstPoint:{},
                CoeffPvReady:1,
                overlay: {},
                aprendre: true,
                pvReady:this.pvready,
                isRoof:false,               
            };
        },
        mounted: function(){
            const token = process.env.MIX_GOOGLE_MAP_KEY;//ok
            const GoogleMap = require("@googlemaps/js-api-loader");//ok

            const loader = new GoogleMap.Loader({
                apiKey: token,
                version: "weekly",
                libraries: ["geometry","marker"]
            });//ok

            this.modifier = this.deja_modifier;

            if(this.zone) {
                this.longitude = this.zone.longitude;
                this.latitude =this.zone.latitude;
                this.comments=this.zone.comments;
                this.idZone=this.zone.id;
                this.type = this.zone.name;
                this.CoeffPvReady = this.zone["CoeffPV-Ready"];
                this.surfaceTotale =this.zone.surfaceTotale;

                if(this.zone.a_prendre==0){
                    this.aprendre = false;
                }               

                if(this.zone.nomzone != undefined) {
                    this.nomZone = this.zone.nomzone;
                }
            } else { // en cas d'ajout de zone
                this.longitude = this.site.longitude;
                this.latitude =this.site.latitude;
                this.idZone=this.site.id;
            }
            
            loader.load().then(() => {
                // Initiate map
                const map = new google.maps.Map(document.querySelector("#map"), {
                    center: { lat: this.latitude, lng: this.longitude },
                    zoom: 19,
                    mapTypeId: google.maps.MapTypeId.SATELLITE,
                    rotateControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    heading: 0,
                    tilt: 0,
                    mapId: "90f87356969d889c",
                });

                if(this.site.imageplan) {
                    var imageplan = this.site.imageplan;
                    const ImagePlanOverlay = require("../maps/imagePlanOverlay.js");
                    const sw = JSON.parse(this.site.imageplan.southwest);
                    const ne = JSON.parse(this.site.imageplan.northeast);
                    const bounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(sw.lat, sw.lng),
                    new google.maps.LatLng(ne.lat, ne.lng)
                    );
                    this.overlay = new ImagePlanOverlay.default(bounds, imageplan.image, imageplan.rotationAngle);

                    this.overlay.setMap(map);
                }
                const { getCadastreLayer, getPLULayer, getOverlayControls } = require("../maps/additional-layers.js");
                const { EnedisHTLines, EnedisBTLines, EnedisDeliveryPosts/*, RteLines, RtePylones, RtePostes */ } = require("../maps/opendata-carto-module.js");

                const overlaysMenu = getOverlayControls({
                    'cadastre': getCadastreLayer(),
                    'urbanism': getPLULayer(map),
                    'ht-lines': new EnedisHTLines(this.longitude, this.latitude, 1),
                    'bt-lines': new EnedisBTLines(this.longitude, this.latitude, 1),
                    'posts': new EnedisDeliveryPosts(this.longitude, this.latitude, 1),
                    //'rte-posts': new RtePostes(this.longitude, this.latitude, 5),
                    //'rte-lines': new RteLines(this.longitude, this.latitude, 5),
                    //'rte-pylones': new RtePylones(this.longitude, this.latitude, 5),
                }, map);

                const menu = document.createElement("div");
                menu.className = "menu menu-right";

                const Regle = require("../maps/regle.js");
                const menuRegle = new Regle.default(map);
                menu.appendChild(menuRegle.getItemMenu());
                const Surface = require("../maps/surface.js");
                const menuSurface = new Surface.default(map);
                menu.appendChild(menuSurface.getItemMenu());

                map.controls[google.maps.ControlPosition.LEFT_TOP].push(menu);
                map.controls[google.maps.ControlPosition.LEFT_TOP].push(overlaysMenu);

                const HTMLMarker = require("../maps/HTMLMarker.js");
                
                // A marker with a with a URL pointing to a PNG.
                const markerSiteImg = document.createElement('img');
                markerSiteImg.src = '/image/maps/marker_blue.png';

                // Initiate base position marker
                const siteMarkerBase = new google.maps.marker.AdvancedMarkerElement({
                    position: { lng: this.longitude, lat: this.latitude },
                    map,
                    gmpDraggable: false,
                    content: markerSiteImg,
                    title:"Site marker",
                });
                
                // A marker with a with a URL pointing to a PNG.
                const markerBuildingImg = document.createElement('img');
                markerBuildingImg.src = '/image/maps/marker_red.png';

                // Initiate draggable marker
                const buildingMarker = new google.maps.marker.AdvancedMarkerElement({
                    position: { lng: this.longitude, lat: this.latitude },
                    map,
                    gmpDraggable: true,
                    content: markerBuildingImg,
                    title:"Building marker"
                });

                google.maps.event.addListener(buildingMarker, 'dragend', (e) => {
                    var long = document.getElementById("longitudeLabel");
                    long.textContent = e.latLng.lng();
                    var lati = document.getElementById("latitudeLabel");
                    lati.textContent = e.latLng.lat();
                });

                if (this.isNew) {

                } else {
                    var data = [];
                    var name = [];
                    this.pvfieldsdraw.forEach(element => {
                        data.push(JSON.parse(element.affichage));
                        name.push(element.name);
                    });
                    var data2 = [];
                    var i = 0;
                    
                    data.forEach(element => {
                        data2.push(element.champ.features);  
                        var center = turf.centerOfMass(element.champ);
                        var marker = new HTMLMarker.default(center.geometry.coordinates[1], center.geometry.coordinates[0], name[i], "fieldMarker"+name[i]);
                        marker.setMap(map);
                        i++;
                    });

                    var data3 = [];
                    var i = 0;

                    while(i<data2.length){
                        var j = 0;
                        while(j<data2[i].length){
                            data3.push(data2[i][j]);
                            j++;
                        }
                        i++;
                    }

                    var pvGrid = {
                        'type': 'FeatureCollection',
                        'features': data3,
                    };

                    map.data.addGeoJson(pvGrid);
                    map.data.setStyle({
                        fillColor: '#000f45',
                        fillOpacity: 0.8,
                        strokeWeight: 0,
                    });
                }
            });
        },
        methods :{
            back(){
                document.getElementById("back").submit();
            },            
            save(){
                document.getElementById('name').value = this.type;


                this.longitude = document.getElementById("longitudeLabel").textContent;
                this.latitude = document.getElementById("latitudeLabel").textContent;
                document.getElementById("latitude").value= this.latitude;
                document.getElementById("longitude").value= this.longitude;                

                if(this.aprendre){                 
                    document.getElementById("a_prendre").value=1;
                }else{                    
                    document.getElementById("a_prendre").value=0;
                }               

                if(this.modifier==true){
                    document.getElementById("CoeffPvReady").value= this.CoeffPvReady;
                }
                
                if (this.is_new) {
                    document.getElementById("zone_ID").value= this.idZone;
                }
                
              
            },
            /**
             * Permet de saisir ou non dans le champs "Coefficient PvReady" en fonction de la sélection du type de champ
             */
             changedTypeZone(){
                if (this.pvReady===1) {
                    var value=document.getElementById('SelectTypeField').value; ;
                    this.isRoof=value==="Roof"?true:false;
                }
            }
        }
    }
</script>
